import { render, staticRenderFns } from "./IntegrationWebHooks.vue?vue&type=template&id=be5ceaf4"
import script from "./IntegrationWebHooks.vue?vue&type=script&lang=js"
export * from "./IntegrationWebHooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports